import TextStyling from './TextStyling';

const LegalDisclaimer = ({ header = '', description = [] } = {}) => ({
  header: String(header),
  description: description.map((item) => TextStyling(item)),
});

export type LegalDisclaimerProps = ReturnType<typeof LegalDisclaimer>;

export default LegalDisclaimer;
